/**
 * Versioni
 * 1001 2022/02/16  porting da js
 * 1002 2024/08/29  migliorie e versione mobile 
 */


export class MapUtils {

  public static geometryArea(geometry:Geometry):number {
    var area = 0;
    var n = geometry.points.length;

    for (var i = 0; i < n; i++) {
        var j = (i + 1) % n;
        var pi = geometry.points[i];
        var pj = geometry.points[j];
        area += pi.x * pj.y;
        area -= pi.y * pj.x;
    }

    return area / 2;
}


  public static distanceLinePoint(p0:IPoint, p1:IPoint, p:IPoint) {
    var r_numerator = (p.x - p0.x) * (p1.x - p0.x) + (p.y - p0.y) * (p1.y - p0.y);
    var r_denomenator = (p1.x - p0.x) * (p1.x - p0.x) + (p1.y - p0.y) * (p1.y - p0.y);
    var r = r_numerator / r_denomenator;

    var s = ((p0.y - p.y) * (p1.x - p0.x) - (p0.x - p.x) * (p1.y - p0.y)) / r_denomenator;

    var distanceLine = Math.abs(s) * Math.sqrt(r_denomenator);

    if ((r >= 0) && (r <= 1)) {
        return distanceLine;
    } else {
        var dist1 = (p.x - p0.x) * (p.x - p0.x) + (p.y - p0.y) * (p.y - p0.y);
        var dist2 = (p.x - p1.x) * (p.x - p1.x) + (p.y - p1.y) * (p.y - p1.y);
        if (dist1 < dist2) {
            return Math.sqrt(dist1);
        } else {
            return Math.sqrt(dist2);
        }
    }
  }

  public static pointInPolygon(p:IPoint, poly:IPoint[]) {
    var i;
    var j = poly.length - 1;
    var oddNodes = false;
    var x = p.x;
    var y = p.y;

    for (i=0; i < poly.length; i++) {
        if ((poly[i].y < y && poly[j].y >=y
            ||   poly[j].y < y && poly[i].y >= y)
            &&  (poly[i].x <= x || poly[j].x <= x)) {
            if (poly[i].x+(y-poly[i].y)/(poly[j].y-poly[i].y)*(poly[j].x-poly[i].x) < x) {
                oddNodes=!oddNodes; }
            }
        j=i;
    }

    return oddNodes;
  }

  public static geometryFromWkt(wkt:string):Geometry {
    var result = new Geometry();
    result.fromWkt(wkt);
    return result;
  }



  public static getGeometryType(wkt:string) {
    if (wkt === "POLYGON" || wkt.substr(0, 7) === "POLYGON") {
        return GeometryType.TYPE_POLYGON;
    } else if (wkt === "MULTILINESTRING" || wkt.substr(0, 15) === "MULTILINESTRING") {
        return GeometryType.TYPE_POLYLINE;
    } else if (wkt === "POINT" || wkt.substr(0, 5) === "POINT") {
        return GeometryType.TYPE_POINT;
    }
  }

  public static respondToVisibility(root:Element, element:Element, callback:Function) {
    let options = {
      root: root,
    };
  
    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        callback(entry.intersectionRatio > 0);
      });
    }, options);
  
    observer.observe(element);
  }

  public static respondToResize(element:Element, callback:Function) {
    let observer = new ResizeObserver((entries, observer) => {
      callback();
    });
  
    observer.observe(element);
  }

  public static debounce<Params extends any[]>(func: (...args: Params) => any,  timeout: number): (...args: Params) => void {
    let timer: NodeJS.Timeout
    return (...args: Params) => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        func(...args)
      }, timeout)
    }
  }


}

export interface IPoint {
  x: number;
  y: number;
}

export interface ISize {
  width:number;
  height:number;
}


export class Point implements IPoint {
  constructor(
    public x:number, 
    public y:number
  ) {
  }

  toString() {
    return "{x:" + this.x + ", y:" + this.y + "}";
  }

}

export interface IMapBounds {
  xMin:number,
  yMin:number,
  xMax:number,
  yMax:number
}


export class Bounds implements IMapBounds {

  public static toBounds(value:any):Bounds {
    if (value instanceof Bounds) {
      return value;
    }
    if (value.minX || value.maxX) {
      return new Bounds(value.minX, value.minY, value.maxX, value.maxY);
    }
    if (value.xMin || value.xMax) {
      return new Bounds(value.xMin, value.yMin, value.xMax, value.yMax);
    }
  }

  constructor(
    public xMin:number,
    public yMin:number,
    public xMax:number,
    public yMax:number
  ) {
  }

  get valid():boolean {
    if (isNaN(this.xMin) || isNaN(this.yMin) || isNaN(this.xMax) || isNaN(this.yMax)) {
      return false;
    }

    if (this.width == 0 || this.height == 0) {
      return false;
    } 

    return true;
  }

  get width():number {
      return this.xMax - this.xMin;
  };

  get height():number {
      return this.yMax - this.yMin;
  };

  get centerX():number {
      return (this.xMin + this.xMax) / 2;
  };


  get centerY() {
      return (this.yMin + this.yMax) / 2;
  };


  get centerPoint():IPoint {
    return {x:(this.xMin + this.xMax) / 2, y:(this.yMin + this.yMax) / 2};
  }

  translate(deltaX:number, deltaY:number):Bounds {
      return new Bounds(this.xMin + deltaX, this.yMin + deltaY, this.xMax + deltaX, this.yMax + deltaY);
  };

  scale(scale:number):Bounds {
      var xc = this.centerX;
      var yc = this.centerY;
      var w = this.width * scale;
      var h = this.height* scale;
      return new Bounds(xc - w / 2, yc - h / 2, xc + w / 2, yc + h / 2);
  };

  scaleAt(scale:number, scaleX:number, scaleY:number):Bounds {
      var x1 = scaleX - scale * (scaleX - this.xMin);
      var y1 = scaleY - scale * (scaleY - this.yMin);

      return new Bounds(x1, y1, x1 + this.width * scale, y1 + this.height * scale);
  };

  offset(offsetX:number, offsetY:number):Bounds {
      return new Bounds(this.xMin - offsetX, this.yMin - offsetY, this.xMax + offsetX, this.yMax + offsetY);
  };


  /**
   * Ritorna un Bound che contenga (x,y)
   */
  expandToInclude(x:number, y:number):Bounds {
      let minx = this.xMin;
      let miny = this.yMin;
      let maxx = this.xMax;
      let maxy = this.yMax;

      if (x < minx) {
          minx = x;
      }
      if (x > maxx) {
          maxx = x;
      }
      if (y < miny) {
          miny = y;
      }
      if (y > maxy) {
          maxy = y;
      }

      return new Bounds(minx, miny, maxx, maxy);
  };

  union(bound:Bounds):Bounds {
      return bound.expandToInclude(this.xMin, this.yMin).expandToInclude(this.xMax, this.yMax);
  };

  center(x:number, y:number) {
      return this.translate(x - this.centerX, y - this.centerY);
  };

  
  toString() {
      return "{xMin:" + this.xMin + ", yMin:" + this.yMin + ", xMax:" + this.xMax + ", yMax:" + this.yMax + "}";
  };
};






export enum GeometryType {
  TYPE_POINT = 1,
  TYPE_POLYLINE = 3,
  TYPE_POLYGON = 5
}


export class Geometry {

  private _type: GeometryType;
  private _points: IPoint[];
  private _bounds:Bounds;
  private _area:number;

  _internalRings: IPoint[][];

  get type(): GeometryType {
    return this._type;
  };

  get points(): IPoint[] {
    return this._points;
  };

  get bounds():Bounds {
    if (!this._bounds) {
      var minx = 999999999;
      var miny = 999999999;
      var maxx = -999999999;
      var maxy = -999999999;

      for (var idx = 0; idx < this._points.length; idx++) {
          var x = this._points[idx].x;
          var y = this._points[idx].y;
          if (x < minx) {
              minx = x;
          }
          if (x > maxx) {
              maxx = x;
          }
          if (y < miny) {
              miny = y;
          }
          if (y > maxy) {
              maxy = y;
          }
      }
      this._bounds = new Bounds(minx, miny, maxx, maxy);
    }
    return this._bounds;
  }

  get area():Number {
    if (typeof this._area == "undefined") {
      let area = 0;
      var n = this._points.length;
  
      for (var i = 0; i < n; i++) {
          var j = (i + 1) % n;
          var pi = this._points[i];
          var pj = this._points[j];
          area += pi.x * pj.y;
          area -= pi.y * pj.x;
      }
  
      this._area = area / 2;
    }
    return this._area;
  }

  private _parsePoints(sPoints: string) {
    var sPoint = sPoints.split(",");
    var points = [];
    for (var j = 0; j < sPoint.length; j++) {
      var sToken = sPoint[j].trim().split(" ");
      var x = parseFloat(sToken[0]);
      var y = parseFloat(sToken[1]);

      points.push({ x: x, y: y });
    }
    return points;
  };

  fromWkt(wkt: string):Geometry {
    this._bounds = undefined;
    this._area = undefined;

    let rings;
    let startData;
    if (wkt === "POLYGON") {
      this._type = 5;
      this._points = [];
    } else if (wkt.substr(0, 7) === "POLYGON") {
      this._type = 5;
      startData = wkt.indexOf("((") + 2;

      rings = wkt.substr(startData, wkt.length - startData - 2).split("), (");

      //Creo una geometria a partire dal WKT
      for (var ringIdx = 0; ringIdx < rings.length; ringIdx++) {
        if (ringIdx === 0) {
          this._points = this._parsePoints(rings[ringIdx]);
        } else {
          if (!this._internalRings) {
            this._internalRings = [];
          }
          this._internalRings.push(this._parsePoints(rings[ringIdx]));
        }
      }
    } else if (wkt === "MULTILINESTRING") {
      this._type = 3;
      this._points = [];
    } else if (wkt.substr(0, 15) === "MULTILINESTRING") {
      this._type = 3;
      startData = wkt.indexOf("((") + 2;

      rings = wkt.substr(startData, wkt.length - startData - 2).split("), (");

      //Creo una geometria a partire dal WKT
      for (var ringIdx = 0; ringIdx < rings.length; ringIdx++) {
        if (ringIdx === 0) {
          this._points = this._parsePoints(rings[ringIdx]);
          break;
        }
      }
    } else if (wkt === "POINT") {
      this._type = 1;
      this._points = [];
    } else if (wkt.substr(0, 5) === "POINT") {
      this._type = 1;

      startData = wkt.indexOf("(") + 1;
      var sPoint = wkt.substr(startData, wkt.length - startData - 1);
      this._points = this._parsePoints(sPoint);
    }

    return this;
  }

  toWkt(): string {
    let wkt:string;
    if (this._type === 5) {
      var points = this._points;
      wkt = "POLYGON ((";
      for (var idx = 0; idx < points.length; idx++) {
        if (idx > 0) {
          wkt += ",";
        }
        wkt += points[idx].x + " " + points[idx].y;
      }
      //wkt += "," + this._points[0].x + " " + this._points[0].y;
      wkt += "))";
    } else if (this._type === 3) {
      wkt = "MULTILINESTRING ((";
      for (var idx = 0; idx < this._points.length; idx++) {
        if (idx > 0) {
          wkt += ",";
        }
        wkt += this._points[idx].x + " " + this._points[idx].y;
      }
      wkt += "))";
    } else if (this._type === 1) {
      wkt = "POINT (" + this._points[0].x + " " + this._points[0].y + ")";
    }

    return wkt;
  };






}

export interface IMapOptions {
  container:Element | string;
  background?:string;
  width?:number;
  height?:number;
  crs?:string;
  mobile?:boolean;
}

export type MapEventType = 'info' | 'resize' | 'bounds';

export interface IMapOnClickListener {
    (point:IPoint, event:MouseEvent|TouchEvent):void;
}

export class Map {

  private initBounds:Bounds;

    _width:number = 0;
    _height:number = 0;
    private _mapBounds:Bounds;
    private _scale:number;
    private _crs:string;

    private _layers:MapLayer[] = [];

    _container:HTMLElement;
    private _mapContainer:HTMLElement;
    background:string;
 
 
    private listeners:{listener:Function, type:MapEventType}[] = [];

    private _geographic:boolean;


    private _onClick:IMapOnClickListener;
    private _onFirstUpdate:Function;
    private _onFirstUpdateDone:boolean;
    private _onUpdate:Function;

    constructor(options:IMapOptions) {
      this._init(options);
    }
 
    addEventListener(listener:any, type?:MapEventType) {
      this.listeners.push({listener:listener, type: type});
    };
 
    removeEventListener(listener:any, type?:MapEventType) {
      for (let i = this.listeners.length - 1; i >= 0; i--) {
          var item = this.listeners[i];
          if (item.listener === listener) {
              if ((type && type == item.type) || !type) {
                  this.listeners = this.listeners.splice(i);
              }
          }
      }
     };
 
    _notifyEvent(type:MapEventType, event:any) {
      for (var i = 0; i < this.listeners.length; i++) {
          var item = this.listeners[i];
          if ((type == item.type) || !item.type) {
              item.listener(event);
          }
      }
    };
 
    get width():number {
      return this._width;
    }
 
    get height():number {
      return this._height;
    }

    get mapBounds():Bounds {
      return this._mapBounds;
    }

    get scale():number {
      return this._scale;
    }

    get layers():MapLayer[] {
        return this._layers;
    }

    get crs():string {
      return this._crs;
    }

    protected getContainerValidSize():ISize {
      const rect = this._mapContainer.getBoundingClientRect();
      if (rect.width == 0 || rect.height == 0) {
        return null;
      }

      return {width:rect.width, height:rect.height};
    }
 
    resize(size:{width:number, height:number} = null) {
         if (!size) {
             size = this.getContainerValidSize();
             if (!size) {
              return;
             }
         }

         this._width = size.width;
         this._height = size.height;
 
         //Resize dei singoli layer
         for (var i = 0; i < this.layers.length; i++) {
             this.layers[i]._resizeCanvas(size);
         }
 
         var bounds = this.mapBounds;
         if (bounds) {
             this.setMapBounds(bounds);
         } else if (this.initBounds) {
           this.setMapBounds(this.initBounds, true);
         }

         this._notifyEvent('resize', {width:this._width, height:this._height});
     };
 
 
     private _normalizeBounds(value:Bounds, ensureVisibility:boolean):Bounds {
         var xyFactor = (this._geographic) ? Math.cos(Math.PI * ((value.yMin + value.yMax) / 2) / 180) : 1;
         //normalizzo i confini per non distorcere
         var scale = this._width / value.width;
         var normalized = new Bounds(value.xMin, value.yMin, value.xMin + value.width, value.yMin + Math.abs(value.height) / value.height * this._height / scale * xyFactor);
         if (ensureVisibility) {
             if (normalized.height < value.height) {
                 normalized = normalized.scale(value.height/normalized.height);
             }
         }
 
         //Centro in base al valore passato
         var centered = normalized.translate(value.centerX - normalized.centerX, value.centerY - normalized.centerY);
         return centered;
     };
 
 
    setMapBounds(value:Bounds, ensureVisibility:boolean = false) {
      this.initBounds = value;

      let normalized = this._normalizeBounds(value, ensureVisibility);
      if (normalized.valid) {
        this._mapBounds = normalized; 


        this._scale = this._width / this._mapBounds.width;
  
        this.updateLayers();
      }

     };
 
     /**
      * @param {kelydra.map.Bounds} value
      * @param {number} delay
      */
    setMapBoundsDelay(value:Bounds, delay:number, ensureVisibility:boolean = false) {
         this._mapBounds = this._normalizeBounds(value, ensureVisibility);
         this._scale = this._width / this._mapBounds.width;
         this._notifyEvent("bounds", {});
 
 
         if (this._lastUpdateLayerId) {
             window.clearTimeout(this._lastUpdateLayerId);
         }
         //Metto in coda l'aggiornamento
         this._lastUpdateLayerId = window.setTimeout(() => {
             this.updateLayers();
         }, delay);
 
         this.repaint();
 
     };
     private _lastUpdateLayerId:number;
 
 
 
    addLayer<L extends MapLayer>(layer:L):L {
         this.layers.push(layer);
         layer.linkToMap(this);
         return layer;
     }
 
     updateLayers() {
         if (this.mapBounds) {
             for (var idx in this.layers) {
                 this.layers[idx].update(this);
             }
             this.repaint();

             if (this._onFirstUpdate && !this._onFirstUpdateDone) {
              this._onFirstUpdate(this);
              this._onFirstUpdateDone = true;
             }


             if (this._onUpdate) {
              this._onUpdate(this);
          }
        }
     }
 
     repaint() {
         for (let idx in this._layers) {
             this._layers[idx].draw();
         }
     }
 
     fromMapPoint(p:IPoint):IPoint {
         var x = (p.x - this._mapBounds.xMin) / this._mapBounds.width * this._width;
         var y = (p.y - this._mapBounds.yMin) / this._mapBounds.height * this._height;
 
         return new Point(x, y);
     }
 
 
     toMapPoint(p:IPoint):IPoint {
         var x = p.x / this._width * this._mapBounds.width + this._mapBounds.xMin;
         var y = (this._height - p.y) / this._height * this._mapBounds.height + this._mapBounds.yMin;
 
         return new Point(x, y);
     }
 
     get pixelSize():number {
         return this._mapBounds.width / this.width;
     }
 
     get Scale():number {
         return this._scale;
     }
 
     get isDragging():boolean {
         return this._dragging;
     };
 
     /**
      * @param {function(point:kelydra.map.Point)} f
      */
     setOnClick(f:IMapOnClickListener) {
         this._onClick = f;
     };
 
     /**
      * @param {function(map:kelydra.map.Map)} f
      */
     setOnUpdate(f:Function) {
         this._onUpdate = f;
     };

     setOnFirstUpdate(f:Function) {
        this._onFirstUpdate = f;
     }
 
     getMousePosition(e:MouseEvent):IPoint {
        let rect = this._container.getBoundingClientRect();
        return new Point(e.clientX - rect.left, e.clientY - rect.top);
     };

     getTouchPosition(e:TouchEvent, index:number = 0):IPoint {
      let rect = this._container.getBoundingClientRect();
      return new Point(e.touches[index].clientX - rect.left, e.touches[index].clientY - rect.top);
   };

 
 
    _startPoint:IPoint;
    _startBounds:Bounds;
    _startDelta:number;
    _disableDragging:boolean;
    _dragging:boolean;
    _dragged:boolean;

    private _mousedown(event:MouseEvent) {
         this._startPoint = this.getMousePosition(event);
         this._startBounds = this.mapBounds;
 
         if (this._disableDragging) {
             return;
         }
 
         this._dragging = true;
         this._dragged = false;
    };

    private _mousemove(event:MouseEvent) {
      if (this._dragging) {
             var eventPoint = this.getMousePosition(event);
             var dx = (eventPoint.x - this._startPoint.x);
             var dy = (eventPoint.y - this._startPoint.y);
 
             if (dx != 0 || dy != 0) {
                 this.mouseDrag(dx,dy);
                 this._dragged = true;
             }
         }
     };

    private _mouseup(event:MouseEvent) {
      this._disableDragging = false;

       this._dragging = false;
       if (this._dragged) {
           this.updateLayers();
       } else {
           if (this._onClick) {
//    			  var p = this.toMapPoint({x:event.clientX, y:event.clientY});
               var p = this.toMapPoint(this.getMousePosition(event));

               this._onClick(p, event);
           }
       }

    }     

     private _touchstart(event:TouchEvent) {
      console.log('touchstart (' + event.touches.length + ')');
       this._startPoint = this.getTouchPosition(event);
       this._startBounds = this.mapBounds;
       if (event.touches.length > 1) {
        let startPoint2 = this.getTouchPosition(event,1);
        this._startDelta = Math.sqrt((this._startPoint.x -  startPoint2.x) * (this._startPoint.x -  startPoint2.x) + (this._startPoint.y -  startPoint2.y) * (this._startPoint.y -  startPoint2.y));
       }

       if (this._disableDragging) {
           return;
       }



       this._dragging = true;
       this._dragged = false;
   };

 


    _touchmove(event:TouchEvent) {
      console.log('touchmove');
      if (this._dragging) {
            if (event.touches.length == 1) {
              console.log('dragging');
 
              var eventPoint = this.getTouchPosition(event);
              var dx = (eventPoint.x - this._startPoint.x);
              var dy = (eventPoint.y - this._startPoint.y);
  
              if (dx != 0 || dy != 0) {
                  this.mouseDrag(dx,dy);
                  this._dragged = true;
              }
            } else if (event.touches.length == 2) {
              console.log('zooming');

              var eventPoint = this.getTouchPosition(event);

              let movePoint1 = this.getTouchPosition(event,0);
              let movePoint2 = this.getTouchPosition(event,1);
              let delta = Math.sqrt((movePoint1.x -  movePoint2.x) * (movePoint1.x -  movePoint2.x) + (movePoint1.y -  movePoint2.y) * (movePoint1.y -  movePoint2.y));
      
              if (this._startDelta != delta) {
                var p = this.toMapPoint({x:(movePoint1.x + movePoint2.x)/2, y:(movePoint1.y + movePoint2.y)/2});
                this.setMapBoundsDelay(this._startBounds.scaleAt(this._startDelta / delta, p.x, p.y), 300);

              }

            }
         }
     };

 
 
 
    

     _touchend(event:TouchEvent) {
      console.log('touchend');
      this._disableDragging = false;

       this._dragging = false;
       if (this._dragged) {
           this.updateLayers();
       } else {
           if (this._onClick) {
               var p = this.toMapPoint(this.getTouchPosition(event));

               //TODO gestire _onTap
               this._onClick(p, null);
           }
       }

   };


 
     mouseDragStart() {
         this._startBounds = this.mapBounds;
     };
 
 
     mouseDrag(dx:number,dy:number) {
         var xyFactor = (this._geographic) ? Math.cos(Math.PI * ((this._startBounds.yMin + this._startBounds.yMax) / 2) / 180) : 1;
 
         var deltaX = dx / this._scale;
         var deltaY = dy * xyFactor / this._scale;
 
         this._mapBounds = this._startBounds.translate(-deltaX, deltaY);
         this._notifyEvent("bounds", {});
         this.repaint();
     };
 
     disableDragging(value:boolean) {
         if (value === false) {
             this._disableDragging = false;
         } else {
             this._disableDragging = true;
             this._dragging = false;
             this._dragged = false;
         }
     };
 
 
     _init(options:IMapOptions) {
         this._layers = [];

         this._mapContainer =  <HTMLElement> (typeof options.container == "string" ? document.getElementById(options.container) : options.container);


 
         var settings = {...{
             'background': 'white',
             'width': this._mapContainer.getBoundingClientRect().width,
             'height': this._mapContainer.getBoundingClientRect().height,
             'bounds': new Bounds(0, 0, 0, 0),
             'crs': 'EPSG:4326',
         }, ...options};
 
         this._width = settings.width;
         this._height = settings.height;
 
         this.background = settings.background;
 
         this._crs = settings.crs;
         if (this._crs === 'EPSG:4326') {
             this._geographic = true;
         } else {
             this._geographic = false;
         }

         let mobile = settings.mobile;
 
 
         this._container = document.createElement('div');//
         this._container.classList.add('kelydra-map-layers');
         this._container.style.position = "absolute";
         this._container.style.width = "100%";
         this._container.style.height = "100%";
         this._container.style.background = this.background;

         this._mapContainer.appendChild(this._container);


         if (mobile) {
          this._container.ontouchstart = (e:TouchEvent) => {
            this._touchstart(e);
          }

          this._container.ontouchend = (e:TouchEvent) => {
            this._touchend(e);
          }

          this._container.ontouchmove = (e:TouchEvent) => {
            this._touchmove(e);
          }



         } else {
          this._container.onmousedown = (e:MouseEvent) => {
            this._mousedown(e);
          }

          this._container.onmouseup = (e:MouseEvent) => {
              this._mouseup(e);
          }

          this._container.onmousemove = (e:MouseEvent) => {
              this._mousemove(e);
          }

          this._container.onwheel = (event:WheelEvent) => {
            //var event = e.originalEvent;
            var delta = event.deltaY / 120;
            
            if (delta != 0) {
                var p = this.toMapPoint(this.getMousePosition(event));
                this.setMapBoundsDelay(this.mapBounds.scaleAt(((delta < 0) ? 0.7 : 1.3), p.x, p.y), 300);
            }
          }
         }


        

        MapUtils.respondToVisibility(this._mapContainer, this._container, (visibility:boolean) => {
          console.log('visible:' + visibility);
          if (visibility) {
            this.resize();
          }
        });

        let resized:boolean = false;
        MapUtils.respondToResize(this._mapContainer, () => {
          console.log('resize');
          this.resize();
        });


     };
 
 
 }

 export interface IMapLayerOptions {
  id?:string;
  caption?:string;
}


 export abstract class MapLayer {

  map:Map;
  info:any;

  renderingBounds:Bounds;

  _id:any;
  _opacity:number = 1.0;
  _visibility:boolean = true;
  _caption:string;

  _canvas:HTMLCanvasElement;

  protected _infoReadyPromise:Promise<any>;
  protected _infoReadyPromiseResolve:(value:any) => void;


  constructor() {
    this._infoReadyPromise = new Promise(resolve => {
      this._infoReadyPromiseResolve = resolve;
    });
  }

  get id():any {
    return this._id;
  }

  get caption():string {
    return this._caption;
  }

  public infoReady():Promise<IKMSServiceInfo> {
    return this._infoReadyPromise;
  }

  protected _init(options:IMapLayerOptions) {
     this._id = options?.id;
     this._caption = options?.caption;
  }

  protected setInfo(info:any, updateMap:boolean, notity:boolean) {
    this.info = info;
    this._infoReadyPromiseResolve(this.info);
    if (updateMap) {
      this.map.updateLayers();
    }

    if (notity) {
      this.map._notifyEvent("info",{});
    }

  }

  linkToMap(map:Map) {
     this.map = map;
     map.updateLayers();
  }

  update(map:Map) {
  }

  draw() {
  }

  getLayerBounds():Bounds {
     return this.renderingBounds;
  };

  getId() {
     return this._id;
  }

  getCaption() {
     return this._caption;
  }

  getLayerType() {
     return "MapLayer";
  }

  fromLayerPoint(p:Point) {
     var _bounds = this.getLayerBounds();

     var x = (p.x - _bounds.xMin) / _bounds.width * this.map._width;
     var y = (p.y - _bounds.yMin) / _bounds.height * this.map._height;

     return new Point(x, y);
  }

  toLayerPoint(p:IPoint) {
     var _bounds = this.getLayerBounds();

     var x = p.x / this.map._width * _bounds.width + _bounds.xMin;
     var y = (this.map._height - p.y) / this.map._height * _bounds.height + _bounds.yMin;

     return new Point(x, y);
 }

 _initCanvas(map:Map) {
     //this._canvas = $("<canvas class='kelydra-map' width=" + map.getWidth() + " height=" + map.getHeight() + " style='position: absolute;'/>").appendTo($(map._container)).get(0);

     this._canvas = document.createElement('canvas');
     this._canvas.classList.add('kelydra-map');
     this._canvas.width = map.width;
     this._canvas.height = map.height;
     this._canvas.style.position = 'absolute';

     this.map._container.appendChild(this._canvas);

     var context = this._canvas.getContext('2d');

     //Posiziono l'origine in basso a sinistra
     context.translate(0, map.height);
     context.scale(1, -1);
 };

 _resizeCanvas(size:{width:number, height:number}) {
     this._canvas.width = size.width;
     this._canvas.height = size.height;

     var context = this._canvas.getContext('2d');
     //resetto le trasformazioni
     context.setTransform(1, 0, 0, 1, 0, 0);

     //Posiziono l'origine in basso a sinistra
     context.translate(0, this.map.height);
     context.scale(1, -1);
 }

 setOpacity(value:number) {
     this._opacity = value;
     this._canvas.style.opacity = String(this._opacity);
 }

 getOpacity() {
     return this._opacity;
 }

 setVisibility(value:boolean) {
     this._visibility = value;
     if (value) {
         this._canvas.style.visibility = 'visible';
     } else {
      this._canvas.style.visibility = 'hidden';
    }
 }

 getVisibility() {
     return this._visibility;
 }

  get opacity():number {
     return this._opacity;
  }

  set opacity(value:number) {
    this.setOpacity(value);
  }

  get visible():boolean {
    return this._visibility;
  }

  set visible(value:boolean) {
    this.setVisibility(value);
  }

 }

 export class MapLayerTest extends MapLayer {

  draw() {
      var context = this._canvas.getContext('2d');
      context.clearRect(0, 0, this._canvas.width, this._canvas.height);

      context.fillStyle = "red";
      context.beginPath();
      context.moveTo(0, 0);
      context.lineTo(this.map.width, this.map.height);
      context.lineTo(0, this.map.height);
      context.closePath();
      context.fill();
  };

  linkToMap(map:Map) {
      this.map = map;
      this._initCanvas(map);
  };

}

export interface IMapLayerKmsOptions extends IMapLayerOptions {
  url:string;
}


export class MapLayerKMS extends MapLayer {
  public static TYPE = "MapLayerKMS";

  url:string;
  renderingImage:HTMLImageElement = null;
  renderingBounds:Bounds = null;
  queryStringExtra:string = null;
  queryStringHiddenLayers:string = null;
  queryStringVisibleLayers:string = null;

  constructor(options:IMapLayerKmsOptions) {
    super();
    this._init(options);
  }

  _init(options:IMapLayerKmsOptions) {
    super._init(options);
    this.url = options.url;
  };

  getLayerType() {
      return MapLayerKMS.TYPE;
  };

  /**
   * @param {string} value
   */
  setQueryStringExtra(value:string) {
      this.queryStringExtra = value;
  };

  /**
   * @returns {null|string}
   */
  getQueryStringExtra() {
      return this.queryStringExtra;
  };


  getQueryStringVisibility():string {
    let queryUrl = '';
    if (this.queryStringHiddenLayers) {
      if (!this.queryStringHiddenLayers.startsWith("hidden=")) {
        queryUrl += "hidden=";
      }
      queryUrl += this.queryStringHiddenLayers
    }


    if (this.queryStringVisibleLayers) {
      if (queryUrl) {
        queryUrl += "&";
      }
      if (!this.queryStringVisibleLayers.startsWith("visible=")) {
        queryUrl += "visible=";
      }
      queryUrl += this.queryStringVisibleLayers;
    }

    return queryUrl;
}

  update(map:Map) {
      var bbox = map.mapBounds;
      var imageUrl = this.url + "/map?width=" + map.width + "&height=" + map.height + "&bbox=" + bbox.xMin + "," + bbox.yMin + "," + bbox.xMax + "," + bbox.yMax;
      if (this.queryStringExtra === null) {
          imageUrl += "&imageType=png&transparent=1";
      } else {
          imageUrl += this.queryStringExtra;
      }

      let queryVisibility = this.getQueryStringVisibility();
      if (queryVisibility) {
        imageUrl += ("&" + queryVisibility);
      }

      imageUrl += "&dummy=" + new Date();

      var image = new Image();
      image.src = imageUrl;
      image.onload = () => {
          this.renderingImage = image;
          this.renderingBounds = bbox;

          this.draw();
      };
  };


  linkToMap(map:Map) {
      this.map = map;
      this._initCanvas(map);


      let init: RequestInit = {
        credentials: "include"
      };

      return fetch(this.url + "/map/info", init).then(async response => {
        let data:any = await response.json();
        this.setInfo(data, true, true);
      });

  }

  draw() {
      var context = this._canvas.getContext('2d');
      context.clearRect(0, 0, this._canvas.width, this._canvas.height);

      if (this.renderingImage !== null) {
          context.save();
          try {
              //Disegno l'immagine scalando in base alla estensione della mappa
              var p1 = this.map.fromMapPoint(new Point(this.renderingBounds.xMin, this.renderingBounds.yMin));
              var p2 = this.map.fromMapPoint(new Point(this.renderingBounds.xMax, this.renderingBounds.yMax));

              context.translate(p1.x, p2.y);
              context.scale(1, -1);

              context.drawImage(this.renderingImage, 0, 0, p2.x - p1.x, p2.y - p1.y);
          } finally {
              context.restore();
          }
      }


  };



}


export class MapLayerWMS extends MapLayer {
  
  url:string;
  cache:boolean;
  renderingImage:HTMLImageElement;
  layers:string;

  _init(options:any) {
    let settings = {...{
      'cache': true,
      'dummy': ''
    }, ...options};

  this.url = settings.url;
  this.cache = settings.cache;
  if (this.url.indexOf('?') === -1) {
      this.url += '?';
  }

  this.layers = settings.layers;
  }


  

  update(map:Map) {
      var bbox = map.mapBounds;
      var imageUrl = this.url + "SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap";
      imageUrl += "&BBOX=" + bbox.yMin + "," + bbox.xMin + "," + bbox.yMax + "," + bbox.xMax;
      imageUrl += "&CRS=" + map.crs;
      imageUrl += "&WIDTH=" + map.width + "&HEIGHT=" + map.height;
      imageUrl += "&LAYERS=" + this.layers;
      imageUrl += "&FORMAT=image/png";
      imageUrl += "&TRANSPARENT=TRUE";

      if (!this.cache) {
          imageUrl += "&_" + (new Date().getTime());
      }

      var image = new Image();
      image.src = imageUrl;
      image.onload = () => {
          this.renderingImage = image;
          this.renderingBounds = bbox;

          this.draw();
      };
  }


  linkToMap(map:Map) {
      this.map = map;

      this._initCanvas(map);

      let init: RequestInit = {
        credentials: "include"
      };


      return fetch(this.url + "/map/info", init).then(async response => {
        let data:any = await response.json();
        this.setInfo(data, true, true);
      });
  }

  draw() {
      var context = this._canvas.getContext('2d');
      context.clearRect(0, 0, this._canvas.width, this._canvas.height);

      if (this.renderingImage !== null) {
          context.save();
          try {
              //Disegno l'immagine scalando in base alla estensione della mappa
              var p1 = this.map.fromMapPoint(new Point(this.renderingBounds.xMin, this.renderingBounds.yMin));
              var p2 = this.map.fromMapPoint(new Point(this.renderingBounds.xMax, this.renderingBounds.yMax));

              context.translate(p1.x, p2.y);
              context.scale(1, -1);

              context.drawImage(this.renderingImage, 0, 0, p2.x - p1.x, p2.y - p1.y);
          } finally {
              context.restore();
          }
      }


  }

}


export class MapLayerImage extends MapLayer {

  public static TYPE = "MapLayerImage";

  renderingImage:HTMLImageElement = null;
  queryStringExtra:string = null;

  setImage(imageUrl:string, imageBounds:Bounds) {
    var image = new Image();
    image.src = imageUrl;
    image.onload = () => {
        this.renderingImage = image;
        this.renderingBounds = imageBounds;

        this.draw();
    };
  }

  clearImage() {
    this.renderingImage = null;
    this.draw();
  }

  linkToMap(map:Map) {
    this.map = map;
    this._initCanvas(map);
  }


  draw() {
    var context = this._canvas.getContext('2d');
    context.clearRect(0, 0, this._canvas.width, this._canvas.height);

    if (this.renderingImage !== null) {
      context.save();
      try {
          //Disegno l'immagine scalando in base alla estensione della mappa
          var p1 = this.map.fromMapPoint(new Point(this.renderingBounds.xMin, this.renderingBounds.yMin));
          var p2 = this.map.fromMapPoint(new Point(this.renderingBounds.xMax, this.renderingBounds.yMax));

          context.translate(p1.x, p2.y);
          context.scale(1, -1);

          context.drawImage(this.renderingImage, 0, 0, p2.x - p1.x, p2.y - p1.y);
      } finally {
          context.restore();
      }
    }
};



}

interface IKMSTile {
  depth: number;
  x: number;
  y: number;
  bounds?:Bounds;
  url?:string;
  image?:HTMLImageElement;
}

export interface IMapLayerTilesKMSOptions extends IMapLayerOptions {
  url:string;
}


export class MapLayerTilesKMS extends MapLayer {

  public static TYPE = "MapLayerTilesKMS";
  
  initialized:boolean;
  renderingImage:HTMLImageElement;
  url:string;
  imageFormat:string;

  _canvasBuffer:HTMLCanvasElement;

  tiles:IKMSTile[] = [];
  tileZoom:number;
  tilesBounds:Bounds;
  tileWidth:number;
  tileHeight:number;
  tileFormat:String;

  constructor(options:IMapLayerTilesKMSOptions) {
    super();
    this._init(options);
  }


  _init(options:IMapLayerTilesKMSOptions) {
      super._init(options);

      this.url = options.url;
      this.map;

  };

  getLayerType = function() {
      return MapLayerTilesKMS.TYPE;
  }


  _initCanvas(map:Map) {
    super._initCanvas(map);
    this._canvasBuffer = document.createElement('canvas');
    this._canvasBuffer.classList.add('kelydra-map');
    this._canvasBuffer.width = map.width;
    this._canvasBuffer.height = map.height;
    this._canvasBuffer.style.position = 'absolute';
    this._canvasBuffer.style.visibility = 'hidden';

    this.map._container.appendChild(this._canvasBuffer);
  };

  _resizeCanvas(size:ISize) {
      this._canvas.width = size.width;
      this._canvas.height = size.height;
      this._canvasBuffer.width = size.width;
      this._canvasBuffer.height = size.height;

      let context = this._canvas.getContext('2d');
      context.clearRect(0, 0, this._canvas.width, this._canvas.height);
      context = this._canvasBuffer.getContext('2d');
      context.clearRect(0, 0, this._canvas.width, this._canvas.height);
  }


  update(map:Map) {
      if (!this.initialized) {
          return;
      };

      var bound = map.mapBounds;
      if (!bound) {
          return;
      }

      if (this._canvas.width == 0 || this._canvas.height == 0) {
        return;
      }

      console.log('TilesKMS update');

      //calcolo il livello di zoom
      var depth = this.tileZoom;
      //Ciclo finche' il rapporto tra i pixel dei tile e quello del layer � compresot tra 1 e 2
      while (true) {
          var dephPixels = (1 << depth) * this.tileWidth;
          var boundPixels = dephPixels * (bound.width / this.tilesBounds.width);
          var ratio = map.width / boundPixels;

          if (ratio >= 0.8 || depth === 0) {
              break;
          }

          depth--;
      }

      //Ricopio e rescalo i dati
      if (this.renderingBounds) {
          let context = this._canvas.getContext('2d');

          context.clearRect(0, 0, this._canvas.width, this._canvas.height);

          context.drawImage(this._canvasBuffer, 0, 0, this._canvas.width, this._canvas.height);


          context = this._canvasBuffer.getContext('2d');
          context.clearRect(0, 0, this._canvas.width, this._canvas.height);

          //Coordinate attualmente visibili
          var visibleBounds = this.renderingBounds;

          //Aggiorno i bounds del layer
          this.renderingBounds = bound;

          var p1 = this.fromLayerPoint(new Point(visibleBounds.xMin, visibleBounds.yMin));
          var p2 = this.fromLayerPoint(new Point(visibleBounds.xMax, visibleBounds.yMax));

          context.drawImage(this._canvas, p1.x, this._canvas.height - p2.y, p2.x - p1.x, p2.y - p1.y);
      } else {
          //Aggiorno i bounds del layer
          this.renderingBounds = bound;
      }

      //Calcolo le immagini da scaricare
      var tileSize = this.tilesBounds.width / (1 << depth);
      var leftIndex = Math.floor((bound.xMin - this.tilesBounds.xMin) / tileSize);
      var topIndex = Math.floor((this.tilesBounds.yMax - bound.yMax) / tileSize); //i valori lungo y sono invertiti


      var y = Math.max(0, topIndex);
      var x;
      this.tiles = [];
      while ((this.tilesBounds.yMax - y * tileSize) > bound.yMin && (y < (1 << depth))) {
          x = Math.max(0, leftIndex);
          while (this.tilesBounds.xMin + x * tileSize < bound.xMax && (x < (1 << depth))) {
              this._loadTile({depth: depth, x: x, y: y});
              x++;
          }
          y++;
      }


      this.draw();
  }


  _loadTile(tile:IKMSTile) {
      tile.bounds = this._calculateTileBound(tile);
      tile.url = this.url + "/" + tile.depth + "/" + tile.x + "/" + tile.y + "." + this.imageFormat;

      this.tiles.push(tile);

      var image = new Image();
      image.src = tile.url;
      image.onload = () => {
          //console.log('loaded tile image:'+tile.url);
          tile.image = image;
          if (this.renderingBounds) {
              let context = this._canvasBuffer.getContext('2d');

              let p1 = this.fromLayerPoint(new Point(tile.bounds.xMin, tile.bounds.yMin));
              let p2 = this.fromLayerPoint(new Point(tile.bounds.xMax, tile.bounds.yMax));

              context.drawImage(tile.image, p1.x, this._canvas.height - p2.y, p2.x - p1.x, p2.y - p1.y);

              this.draw();
          }

      };

  };

  _calculateTileBound(tile:IKMSTile) {
      var tileSize = this.tilesBounds.width / (1 << tile.depth);
      var x = tile.x;
      var y = tile.y;
      return new Bounds(this.tilesBounds.xMin + x * tileSize, this.tilesBounds.yMax - (y + 1) * tileSize, this.tilesBounds.xMin + (x + 1) * tileSize, this.tilesBounds.yMax - y * tileSize);
  };


  _serviceInfo(xml:string) {
    const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xml, "application/xml");

      var xMin = Number(xmlDoc.querySelector('Xmin').textContent);
      var yMin = Number(xmlDoc.querySelector('Ymin').textContent);
      var xMax = Number(xmlDoc.querySelector('Xmax').textContent);
      var yMax = Number(xmlDoc.querySelector('Ymax').textContent);

      this.tilesBounds = new Bounds(xMin, yMin, xMax, yMax);

      this.tileZoom = Number(xmlDoc.querySelector('Zoom').textContent);

      this.tileWidth = Number(xmlDoc.querySelector('Width').textContent);
      this.tileHeight = Number(xmlDoc.querySelector('Height').textContent);
      this.tileFormat = xmlDoc.querySelector('Format').textContent;
      this.imageFormat = this.tileFormat.substring(6);

      this.initialized = true;
      this.setInfo(xmlDoc, true, true);
  }

  linkToMap(map:Map) {
      this.map = map;
      this._initCanvas(map);

      let init: RequestInit = {
        credentials: "include"
      };


      return fetch(this.url + "/toc.xml", init).then(async response => {
        let data:any = await response.text();
        this._serviceInfo(data);
      });
  }

  draw() {
      var context = this._canvas.getContext('2d');

      context.clearRect(0, 0, this._canvas.width, this._canvas.height);


      if (this.renderingBounds) {
          var p1 = this.map.fromMapPoint(new Point(this.renderingBounds.xMin, this.renderingBounds.yMin));
          var p2 = this.map.fromMapPoint(new Point(this.renderingBounds.xMax, this.renderingBounds.yMax));

          context.drawImage(this._canvasBuffer, p1.x, this._canvas.height - p2.y, p2.x - p1.x, p2.y - p1.y);
      }


  };


}




export class MapLayerSelection extends MapLayer {

  lineWidth = 3;
  markerStroke = 'rgb(48, 48, 48)';
  markerFill = 'rgba(0, 0, 0, 0.5)';


  _mode:'rectangle'|'circle' = null;

  _startPoint:IPoint = null;
  _dragPoint:IPoint = null;

  _dragPointIdx:number;
  _geometry:Geometry;

  _onConfirm:(bounds:Bounds, ctrl:boolean) => void;
  _onCancel:Function;

  _mousedownHandler:(event:MouseEvent) => any;
  _mouseupHandler:(event:MouseEvent) => any;
  _mousemoveHandler:(event:MouseEvent) => any;

 

  constructor() {
    super();
    this._mousedownHandler = (event:MouseEvent) => this._mousedown(event);
    this._mouseupHandler = (event:MouseEvent) => this._mouseup(event);
    this._mousemoveHandler = (event:MouseEvent) => this._mousemove(event);
    this._init({});
  }

  _init(options:any) {
  };

  startSelection(onConfirm:(bounds:Bounds, ctrl:boolean) => void, mode:'rectangle' = 'rectangle') {
      this._onConfirm = onConfirm;

      this._mode = mode ? mode : 'rectangle';

      //Verifico se si tratta di un
      this.map._container.style.cursor = "crosshair";
      this.map._container.addEventListener('mousedown', this._mousedownHandler);
      this.map._container.addEventListener('mouseup', this._mouseupHandler);
      this.map._container.addEventListener('mousemove', this._mousemoveHandler);

      this.draw();
  }

  stopSelection() {
    this.map._container.style.cursor = "auto";
    this.map._container.removeEventListener('mousedown', this._mousedownHandler);
    this.map._container.removeEventListener('mouseup', this._mouseupHandler);
    this.map._container.removeEventListener('mousemove', this._mousemoveHandler);
    this.map.disableDragging(false);

    this._dragPointIdx = -1;
    this._geometry = null;
    this.draw();
  }

  update(map:Map) {
  }

  linkToMap(map:Map) {
      this.map = map;

      this._initCanvas(map);
  };

  _mousedown(event:MouseEvent) {
      this._startPoint = this.map.toMapPoint(this.map.getMousePosition(event));
      this._dragPoint = this._startPoint;
      this.map.disableDragging(true);
  };

  _mousemove(event:MouseEvent) {
      if (this._startPoint != null) {
          this._dragPoint = this.map.toMapPoint(this.map.getMousePosition(event));
          this.draw();
      }
  };

  _mouseup(event:MouseEvent) {
      var xMin = Math.min(this._startPoint.x, this._dragPoint.x);
      var yMin = Math.min(this._startPoint.y, this._dragPoint.y);
      var xMax = Math.max(this._startPoint.x, this._dragPoint.x);
      var yMax = Math.max(this._startPoint.y, this._dragPoint.y);
      var selection = new Bounds(xMin,yMin,xMax,yMax);
      this._startPoint = null;
      this._dragPoint = null;
      this.clear();
      if (this._onConfirm) {
        this._onConfirm(selection, event.ctrlKey);
      }
  };


  clear() {
      var context = this._canvas.getContext('2d');
      context.clearRect(0, 0, this._canvas.width, this._canvas.height);
  }

  draw() {
      if (this._startPoint === null) {
          return;
      }

      var context = this._canvas.getContext('2d');
      context.clearRect(0, 0, this._canvas.width, this._canvas.height);

      if (this._dragPoint === null) {
          return;
      }


      if (this._mode != 'circle') {
          var p1 = this.map.fromMapPoint(this._startPoint);
          var p2 = this.map.fromMapPoint(this._dragPoint);
          context.beginPath();
          context.moveTo(p1.x, p1.y);
          context.lineTo(p2.x, p1.y);
          context.lineTo(p2.x, p2.y);
          context.lineTo(p1.x, p2.y);
          context.closePath();
          context.fillStyle = this.markerFill;
          context.fill();
          context.lineWidth = this.lineWidth;
          context.strokeStyle = this.markerStroke;
          context.stroke();
      }
  };

};


export interface IMapLayerAcetateOptions extends IMapLayerOptions {
}



export class MapLayerAcetate extends MapLayer {

  protected objects:AcetateGeometry<any>[] = [];
  protected objectsId:{[id:string]:AcetateGeometry<any>} = {};

  constructor(options:IMapLayerAcetateOptions) {
    super();
    this._init(options);
  }

  _init(settings:IMapLayerAcetateOptions) {
  }

  get acetates():AcetateGeometry<any>[] {
    return this.objects;
}


  addAcetate(object:AcetateGeometry<any>, id?:string|number) {
    this.objects.push(object);
    if (id) {
        if (typeof object !== "string") {
            id = id.toString();
        }
        object.id = id;
        this.objectsId[id] = object;
    }
    this.draw();
    return object;
  }

  removeAcetate(object:any) {
      if (typeof object === "string") {
          var acetate = this.objectsId[object];
          delete this.objectsId[object];
          object = acetate;
      }
      var idx = this.objects.indexOf(object);
      if (idx >= 0) {
          this.objects.splice(idx, 1);
          this.draw();
      }
  }

  removeAcetateId(id:any) {
      if (typeof id !== "string") {
          id = id.toString();
      }
    this.removeAcetate(id);
  }



  clearAll() {
      this.objects = [];
      this.objectsId = {};
      this.draw();
  }

  update(map:Map) {
  }

  linkToMap(map:Map) {
      this.map = map;

      this._initCanvas(map);
  }

  draw() {
      const context = this._canvas.getContext('2d');
      context.clearRect(0, 0, this._canvas.width, this._canvas.height);

      for (var idx = 0; idx < this.objects.length; idx++) {
          var object = this.objects[idx];
          if (object.draw) {
              object.draw(this, context);
          }
      }
  }

}

export class AcetateGeometry<D> {
  id:any;
  _geometry:Geometry;
  markerFill:string;
  markerStroke:string;
  markerRadius:number;
  data:D;

  constructor(geometry:Geometry, fill?:string, stroke?:string, radius?:number) {
    this._geometry = geometry;
    this.markerFill = fill ? (fill !== "trasparent" ? fill : null) : 'rgba(255, 255, 0, 0.5)';
    this.markerStroke = stroke ? stroke : 'rgb(255, 255, 0)';
    this.markerRadius = radius ? radius : 5;
    this.data = null;
  
  }

  get geometry() {
      return this._geometry;
  };


  draw(layer:MapLayerAcetate, context:CanvasRenderingContext2D) {
      if (this._geometry === null) {
          return;
      }

      var map = layer.map;

      var points = this._geometry.points;
      var type = this._geometry.type;

      if (type === 5 || type === 3) {
          context.beginPath();
          var p = map.fromMapPoint(points[0]);
          context.moveTo(p.x, p.y);
          var pointsLength = (type === 3) ?  points.length : points.length - 1;
          for (var idx = 1; idx < pointsLength; idx++) {
              p = map.fromMapPoint(points[idx]);
              context.lineTo(p.x, p.y);
          }
          if (type === 5) {
              context.closePath();

              if (this._geometry._internalRings) {
                  for (var ringIdx = 0; ringIdx < this._geometry._internalRings.length; ringIdx++) {
                      points = this._geometry._internalRings[ringIdx];
                      var p = map.fromMapPoint(points[0]);
                      context.moveTo(p.x, p.y);
                      var pointsLength = points.length - 1;
                      for (var idx = 1; idx < pointsLength; idx++) {
                          p = map.fromMapPoint(points[idx]);
                          context.lineTo(p.x, p.y);
                      }
                      context.closePath();
                  }
              }


              if (this.markerFill) {
                  context.fillStyle = this.markerFill;
                  context.fill();
              }
          }
          context.lineWidth = 5;
          context.strokeStyle = this.markerStroke;
          context.stroke();
      } else if (type === 1) {
          var p = map.fromMapPoint(points[0]);
          context.beginPath();
          context.arc(p.x, p.y, this.markerRadius, 0, 2 * Math.PI, false);
          context.fillStyle = this.markerFill;
          context.fill();
      }


  }
}

export class AcetateWKT<D> extends AcetateGeometry<D> {

  constructor(protected wkt:string) {
    super(new Geometry().fromWkt(wkt));
  }

  getWkt() {
    return this.wkt;
  }
}

export class AcetateImage<D> extends AcetateGeometry<D> {

  _image:HTMLImageElement;

  constructor(geometry:any, public readonly image:string | HTMLImageElement, public readonly deltaX:number = 0, public readonly deltaY:number = 0) {
    super(geometry);
    if (typeof image === 'string') {
      this._image = new Image();
      this._image.src = image;
    } else {
      this._image = image;
    }
  }


  draw(layer:MapLayerAcetate, context:CanvasRenderingContext2D) {
    if (this._image === null) {
          return;
      }

      var map = layer.map;


      if (this._geometry && this._image) {
          var points = this._geometry.points;
          var type = this._geometry.type;

          context.save();
          try {
              var p = map.fromMapPoint(points[0]);
              context.translate(p.x, p.y);
              context.scale(1,-1);
              context.translate(this.deltaX , this.deltaY);
              context.drawImage(this._image,0,0);
          } finally {
              context.restore();
          }

      }
  }


}




export interface IMapLayerEditorOptions extends IMapLayerOptions {
  markerRadius?:number;
  markerStroke?:string;
  markerStrokeSize?:number;
  markerFill?:string;
  markerSelected?:string;
}

export type EditMode = 'insert' | 'edit';

export class MapLayerEditor extends MapLayer {

  markerRadius:number = 5;
  markerStroke = 'rgb(255, 0, 0)';
  markerStrokeSize = 5;
  markerFill = 'rgba(255, 0, 0, 0.5)';
  markerSelected = "yellow";


  _mode:EditMode;

  _geometry:Geometry = null;
  _dragPointIdx = -1;
  _overPointIdx = -1;
  _overLineIdx = -1;

  _mousedownHandler:(event:MouseEvent) => any;
  _mouseupHandler:(event:MouseEvent) => any;
  _mousemoveHandler:(event:MouseEvent) => any;
  _dblclickHandler:(event:MouseEvent) => any;
  _keydownHandler:(event:KeyboardEvent) => any;


  _onConfirm:(wkt:string) => void;
  _onCancel:() => void;

  constructor(options:IMapLayerEditorOptions) {
    super();
    this._mousedownHandler = (event:MouseEvent) => this._mousedown(event);
    this._mouseupHandler = (event:MouseEvent) => this._mouseup(event);
    this._mousemoveHandler = (event:MouseEvent) => this._mousemove(event);
    this._dblclickHandler = (event:MouseEvent) => this._dblclick(event);
    this._keydownHandler = (event:KeyboardEvent) => this._keydown(event);

    this._init(options);
  }


  _init(settings:IMapLayerEditorOptions) {

      if (settings.markerRadius) {
          this.markerRadius = settings.markerRadius;
      }

      if (settings.markerStroke) {
          this.markerStroke = settings.markerStroke;
      }

      if (settings.markerStrokeSize) {
          this.markerStrokeSize = settings.markerStrokeSize;
      }

      if (settings.markerFill) {
          this.markerFill = settings.markerFill;
      }

      if (settings.markerSelected) {
          this.markerSelected = settings.markerSelected;
      }

  }

  startEdit(wkt:string, onConfirm:(wkt:string) => void, onCancel?:() => void) {
      this.cancelEdit();
      this._geometry = new Geometry();
      this._geometry.fromWkt(wkt);

      this._onConfirm = onConfirm;
      this._onCancel = onCancel;

      if (this._geometry.points.length === 0) {
          //insert
          this._mode = "insert";
          this._addPoint(null);
      } else {
          this._mode = "edit";
      }

      this.registerListener();

      this.draw();
  };

  stopEdit() {
      this.cancelEdit();
  };

  _addPoint(p:IPoint) {
      this._geometry.points.push(p);
     this._dragPointIdx = this._geometry.points.length - 1;

  }

  _cleanPoints() {
      for (var i = this._geometry.points.length - 1; i > 1; i--) {
          if (this._geometry.points[i].x == this._geometry.points[i-1].x && this._geometry.points[i].y == this._geometry.points[i-1].y) {
              this._geometry.points.splice(i);
          }
      }
      //Se è un polygono aggiungo il primo punto
      if (this._geometry.type == GeometryType.TYPE_POLYGON) {
          this._geometry.points.push(new Point(this._geometry.points[0].x, this._geometry.points[0].y));
      }
  }

  cancelEdit() {
    this.unregisterListener();

    this.map.disableDragging(false);

    this._dragPointIdx = -1;
    this._geometry = null;
    this._mode = null;
    this.draw();
  };

  protected registerListener() {
    //Verifico se si tratta di un
    this.map._container.style.cursor =  "crosshair";
    this.map._container.addEventListener('mousedown', this._mousedownHandler);
    this.map._container.addEventListener('mouseup', this._mouseupHandler);
    this.map._container.addEventListener('mousemove', this._mousemoveHandler);
    this.map._container.addEventListener('dblclick', this._dblclickHandler);

    document.addEventListener('keydown', this._keydownHandler);
  }

  protected unregisterListener() {
    this.map._container.style.cursor = "auto";
    this.map._container.removeEventListener('mousedown', this._mousedownHandler);
    this.map._container.removeEventListener('mouseup', this._mouseupHandler);
    this.map._container.removeEventListener('mousemove', this._mousemoveHandler);
    this.map._container.removeEventListener('dblclick', this._dblclickHandler);

    document.removeEventListener('keydown', this._keydownHandler);

  }



  get mode() {
      return this._mode;
  }

  get geometry():Geometry {
      return this._geometry;
  };

  get incomplete():boolean {
    switch (this._geometry.type) {
      case GeometryType.TYPE_POINT: return this._geometry.points.length == 0;
      case GeometryType.TYPE_POLYLINE: return this._geometry.points.length < 2;
      case GeometryType.TYPE_POLYGON: return this._geometry.points.length < 3;
    }
  }

  get wkt():string {
      return this._geometry.toWkt();
  };

  update(map:Map) {
  };

  linkToMap(map:Map) {
      this.map = map;

      this._initCanvas(map);
  };

  _mousedown(event:MouseEvent) {
    this.internalMouseDown(this.map.toMapPoint(this.map.getMousePosition(event)));
    this.draw();
  };

  _mousemove(event:MouseEvent) {
      this.internalMouseMove(this.map.toMapPoint(this.map.getMousePosition(event)));
      this.draw();
  };

  _mouseup(event:MouseEvent) {
    this.internalMouseUp(this.map.toMapPoint(this.map.getMousePosition(event)));
    this.draw();
  };

  _dblclick(event:MouseEvent) {
    this.internalMouseDblClick(this.map.toMapPoint(this.map.getMousePosition(event)));
    this.draw();
  };

  _keydown(event:KeyboardEvent) {
    if (event.keyCode == 46) {
      this.internalDeletePoint();
    }
  };

  protected internalDeletePoint() {
    if (this._overPointIdx >= 0) {
      if (this._overPointIdx == 0 || this._overPointIdx == (this._geometry.points.length - 1)) {
          this._geometry.points.splice(this._overPointIdx,1);
          this._geometry.points[this._geometry.points.length - 1] = this._geometry.points[0];
      } else {
          this._geometry.points.splice(this._overPointIdx,1);
      }
      this._overPointIdx = -1;
      this.draw();

      if (this._onConfirm) {
          this._onConfirm(this._geometry.toWkt());
      }
  }
}


  protected internalMouseMove(p:IPoint) {
    if (!this._mode) {
      return;
    }
    var type = this._geometry.type;
    if (this._dragPointIdx >= 0) {
        this._geometry.points[this._dragPointIdx] = p;
        //Gestisco caso polygon e selezione primo punto
        if (this._dragPointIdx === 0 && type === 5) {
            this._geometry.points[this._geometry.points.length - 1] = p;
        }
    } else {
        //Verifico se mi trovo nelle vicinanze di un punto o in mezzo ad una linea
        var points = this._geometry.points;
        var pixelSize = 1 / this.map.scale;
        this._overPointIdx = -1;
        this._overLineIdx = -1;
        for (var idx = 0; idx < points.length; idx++) {
            var dx = (p.x - points[idx].x);
            var dy = (p.y - points[idx].y);
            if ((dx * dx + dy * dy) < 25 * pixelSize * pixelSize) {
                this._overPointIdx = idx;
                break;
            }
        }

        if (this._overPointIdx === -1) {
            //Verifico se sono in mezzo ad un arco
            for (var idx = ((type === 5) ? 0 : 1); idx < points.length; idx++) {
                var p0 = points[idx];
                var p1 = (idx === 0) ? points[points.length - 1] : points[idx - 1];

                var distance = MapUtils.distanceLinePoint(p0, p1, p);
                if (distance < 5 * pixelSize) {
                    this._overLineIdx = idx;
                    break;
                }
            }
        }
    }
  }

  protected internalMouseDown(p:IPoint):boolean {
    if (this._mode === "edit") {
      if (this._dragPointIdx === -1) {
          //Seleziono il punto da editare
          if (this._overPointIdx !== -1) {
            this._dragPointIdx = this._overPointIdx;
            this.map.disableDragging(true);
            return true;
          } else if (this._overLineIdx !== -1){
              //Aggiungo un punto
              this._geometry.points.splice(this._overLineIdx,0,p);
              this._dragPointIdx = this._overLineIdx;
              return true;
          }
      }
    }
    return false;
  }

  protected internalMouseUp(p:IPoint):boolean {
    if (this._mode === "edit") {
      if (this._dragPointIdx !== -1) {
          this._dragPointIdx = -1;
          //evento di fine editing
          if (this._onConfirm) {
              this._onConfirm(this._geometry.toWkt());
          }

          return true;
      }

    } else if (this._mode === "insert" && this._dragPointIdx > 0) {
        this._addPoint(p);
        return true;
    }

    return false;
  }

  protected internalMouseDblClick(p:IPoint):boolean {
      //Inizio o termino un editing
      if (this._mode === "insert" && this._dragPointIdx === 0) {
        if (this._geometry.type === GeometryType.TYPE_POINT) {
            this._dragPointIdx = -1;
        } else {
            this._addPoint(p);
            return true;
        }
    }

    this._dragPointIdx = -1;
    this._mode = "edit";
    this._cleanPoints();
    //evento di fine editing
    if (this._onConfirm) {
        this._onConfirm(this._geometry.toWkt());
    }

  }



  _drawPoint(context:CanvasRenderingContext2D, mapPoint:IPoint, fill:string) {
      var p = this.map.fromMapPoint(mapPoint);
      context.beginPath();
      context.arc(p.x, p.y, this.markerRadius, 0, 2 * Math.PI, false);
      context.fillStyle = fill;
      context.fill();
  };

  draw() {
      var context = this._canvas.getContext('2d');
      context.lineJoin = 'round';
      context.clearRect(0, 0, this._canvas.width, this._canvas.height);

      if (this._geometry === null) {
          return;
      }

      var points = this._geometry.points;
      var type = this._geometry.type

      if (points.length === 0 || (points.length === 1 && points[0] == null)) {
          return;
      }

      if (type === GeometryType.TYPE_POLYGON || type === GeometryType.TYPE_POLYLINE) {
          context.beginPath();
          var p = this.map.fromMapPoint(points[0]);
          context.moveTo(p.x, p.y);
          for (var idx = 1; idx < points.length; idx++) {
              p = this.map.fromMapPoint(points[idx]);
              context.lineTo(p.x, p.y);
          }
          if (type === GeometryType.TYPE_POLYGON) {
              context.closePath();
              context.fillStyle = this.markerFill;
              context.fill();
          }
          context.lineWidth = this.markerStrokeSize;
          context.strokeStyle = this.markerStroke;
          context.stroke();
      }


      //Disegno tutti i punti tranne quello in drag
      for (var idx = 0; idx < points.length; idx++) {
          if (this._dragPointIdx !== idx || this._overPointIdx !== idx) {
              this._drawPoint(context, points[idx], this.markerStroke);
          }
      }

      //Disegna il punto di drag
      if (this._dragPointIdx >= 0 && points[this._dragPointIdx] !== null) {
          this._drawPoint(context, points[this._dragPointIdx], this.markerSelected);
      }

      //Evidenzia il punto o la linea selezionabili
      if (this._dragPointIdx === -1) {
          if (this._overPointIdx >= 0) {
              this._drawPoint(context, points[this._overPointIdx], this.markerSelected);
          } else if (this._overLineIdx >= 0) {
              var p0 = this.map.fromMapPoint(points[this._overLineIdx]);
              var p1 = this.map.fromMapPoint(points[(this._overLineIdx === 0) ? (points.length - 1) : (this._overLineIdx - 1) ]);
              context.beginPath();
              context.moveTo(p0.x, p0.y);
              context.lineTo(p1.x, p1.y);
              context.lineWidth = this.markerStrokeSize;
              context.strokeStyle = this.markerSelected;
              context.stroke();
          }
      }
  };

};

export type OnEditPointCallback = (action:'add' | 'move' | 'focus-point' | 'focus-line' | 'blur') => void;

/**
 * Editing con punto fisso al centro dello schermo
 */
export class MapLayerEditorMobile extends MapLayerEditor {

  protected rollbackPoint:IPoint;
  protected onEditPoint: OnEditPointCallback;
  _onMapBoundsEvent: (event:any) => void;

  constructor(options:IMapLayerEditorOptions) {
    super(options);
    this._onMapBoundsEvent = ((event:any) => this.onMapBoundsEvent());
  }

  startEdit(wkt: string, onConfirm: (wkt: string) => void, onCancel?: () => void, onEditPoint?: OnEditPointCallback): void {
    super.startEdit(wkt, onConfirm, onCancel);
    this.onEditPoint = onEditPoint;
    if (this.mode == "insert") {
      this.internalMouseMove(this.map.mapBounds.centerPoint);
      this.draw();
      this.onEditPoint ?  this.onEditPoint("add") : null;
    }
  }

  protected internalMouseMove(p: IPoint): void {
    const prevOverLineIdx =  this._overLineIdx
    const prevOverPointIdx =  this._overPointIdx;
    super.internalMouseMove(p);
    if (this.onEditPoint) {
      if (this._overPointIdx != prevOverPointIdx) {
        if (this._overPointIdx !==-1) {
          this.onEditPoint("focus-point")
        } else {
          this.onEditPoint("blur")
        }
      } else if (this._overLineIdx != prevOverLineIdx) {
        if (this._overLineIdx !==-1) {
          this.onEditPoint("focus-line")
        } else {
          this.onEditPoint("blur")
        }
      }
    }
  }


  public positionConfirm(done:boolean = false) {
    if (this._dragPointIdx == -1) {
      const action = this._overLineIdx !== -1 ? 'add' : 'move'; 
      this.internalMouseDown(this.map.mapBounds.centerPoint);
      this.map.disableDragging(false);

      if (this._dragPointIdx !== -1) {
        this.rollbackPoint = this._geometry.points[this._dragPointIdx];
        this.onEditPoint ?  this.onEditPoint(action) : null;
      }
    } else {
      if (done || (this._mode === "insert" && this._dragPointIdx === 0)) {
        this.internalMouseDblClick(this.map.mapBounds.centerPoint);
      } else {
        this.internalMouseUp(this.map.mapBounds.centerPoint);
      }
      this.onEditPoint ?  this.onEditPoint("blur") : null;
      if (this._dragPointIdx !== -1) {
        this.onEditPoint ?  this.onEditPoint("add") : null;
      }
    }
    this.draw();
  }

  public positionCancel() {
    if (this._dragPointIdx !== -1) {
      this._geometry.points[this._dragPointIdx] = this.rollbackPoint;
      this._dragPointIdx = -1;
      this._overPointIdx = -1;
      this.draw();
      this.onEditPoint ?  this.onEditPoint("blur") : null;
    }
  }

  public positionDelete() {
    this.internalDeletePoint();
    this.onEditPoint ?  this.onEditPoint("blur") : null;
  }


  protected registerListener(): void {
    this.map.addEventListener(this._onMapBoundsEvent, 'bounds');
  }

  protected unregisterListener(): void {
    this.map.removeEventListener(this._onMapBoundsEvent, 'bounds');
  }

  protected onMapBoundsEvent() {
    this.internalMouseMove(this.map.mapBounds.centerPoint);
  }

}

export class MapLayerMeasure extends MapLayerEditor {
  markerCloseStroke = 'rgb(255, 0, 0)';
  markerCloseSize = 1;
  _onChange:(wkt:string) => void;



  public startMeasure(onConfirm:(wkt:string) => void, onChange?:(wkt:string) => void) {
    super.startEdit("MULTILINESTRING",onConfirm);
    this._onChange = onChange;
  }

  public cancelMeasure() {
    this.cancelEdit();
  }

  _mouseup(event:MouseEvent) {
    super._mouseup(event);
    if (this._mode === "insert" && this._dragPointIdx > 0) {
      if (this._onChange) {
        this._onChange(this._geometry.toWkt());
      }
  }
  }



  draw() {
    var context = this._canvas.getContext('2d');
    context.lineJoin = 'round';
    context.clearRect(0, 0, this._canvas.width, this._canvas.height);

    if (this._geometry === null) {
        return;
    }

    var points = this._geometry.points;
    var type = this._geometry.type

    if (points.length === 0 || (points.length === 1 && points[0] == null)) {
        return;
    }

    if (points.length > 1) {
      context.beginPath();
      const pStart = this.map.fromMapPoint(points[0]);
      context.moveTo(pStart.x, pStart.y);
      let p;
      context.strokeStyle = this.markerStroke;
      context.lineWidth = this.markerStrokeSize;
      for (var idx = 1; idx < points.length; idx++) {
          p = this.map.fromMapPoint(points[idx]);
          context.lineTo(p.x, p.y);
      }
      context.stroke();
      context.closePath();
      context.fillStyle = this.markerFill;
      context.fill();
  
      context.beginPath();
      context.moveTo(pStart.x, pStart.y);
      context.lineTo(p.x, p.y);
  
      context.lineWidth = this.markerCloseSize;
      context.strokeStyle = this.markerCloseStroke;
      context.stroke();
  
    }

    //Disegno tutti i punti tranne quello in drag
    for (var idx = 0; idx < points.length; idx++) {
        if (this._dragPointIdx !== idx || this._overPointIdx !== idx) {
            this._drawPoint(context, points[idx], this.markerStroke);
        }
    }

    //Disegna il punto di drag
    if (this._dragPointIdx >= 0 && points[this._dragPointIdx] !== null) {
        this._drawPoint(context, points[this._dragPointIdx], this.markerSelected);
    }

    //Evidenzia il punto o la linea selezionabili
    if (this._dragPointIdx === -1) {
        if (this._overPointIdx >= 0) {
            this._drawPoint(context, points[this._overPointIdx], this.markerSelected);
        } else if (this._overLineIdx >= 0) {
            var p0 = this.map.fromMapPoint(points[this._overLineIdx]);
            var p1 = this.map.fromMapPoint(points[(this._overLineIdx === 0) ? (points.length - 1) : (this._overLineIdx - 1) ]);
            context.beginPath();
            context.moveTo(p0.x, p0.y);
            context.lineTo(p1.x, p1.y);
            context.lineWidth = this.markerStrokeSize;
            context.strokeStyle = this.markerSelected;
            context.stroke();
        }
    }
  };

}


export interface IMapLayerBalloonOptions extends IMapLayerOptions {
  height?:number;
  width?:number;
}

export class MapLayerBalloon extends MapLayer{

  height:number;
  width:number;
  position:IPoint;

  _balloon:HTMLElement;
  _balloonContent:HTMLElement;
  _arrowSouth:HTMLElement;
  _arrowNorth:HTMLElement;

  constructor(options:IMapLayerBalloonOptions) {
    super();
    this._init(options);
  }

  _init(options:IMapLayerBalloonOptions) {
      let settings = {...{
          height:160,
          width:260,
      }, ...options};


      this.height = settings.height;
      this.width = settings.width;
      this.position = null;

  };

  _initCanvas(map:Map) {
      var _this = this;

      this._balloon = document.createElement('div');
      this._balloon.style.position = "absolute";
      this._balloon.style.background = "#ffffdd";
      this._balloon.style.borderRadius = "10px";
      this._balloon.style.border = "1px solid grey";
      this._balloon.style.minHeight = "100px";
      this._balloon.style.width = "300px";
      this._balloon.style.zIndex = "10";
      this._balloon.style.boxShadow = "5px 5px 15px 0px #000000";

      this._balloon.style.display = 'none';

      this._balloon.style.width = this.width+'px';
      this._balloon.style.height = this.height+'px';

      this.map._container.parentElement.appendChild(this._balloon);

      //
      this._balloonContent = document.createElement('div');
      this._balloonContent.classList.add('popup-content');
      this._balloonContent.style.cssText = "position: absolute;overflow: auto;top: 20px;left: 4px; right: 4px;bottom: 6px;"
      this._balloon.appendChild(this._balloonContent);

      //Arrow
      this._arrowSouth = document.createElement('div');
      this._arrowSouth.style.position = "absolute";
      this._arrowSouth.style.width = "23px";
      this._arrowSouth.style.height = "12px";
      this._arrowSouth.style.background = "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAMCAYAAACJOyb4AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAa0lEQVR4nK3NsRGAMAiF4XjHaO7ECjCRrZupFLmLMYSnQgUU308icjBzyR5VLbTt63KtqQGDzSU7MgMVtp3qMyPQwjf8b6CHH/jXwAge4m8DHuziaGAGT/EoEMEh7gUQGML7AArDeBtAYZsTi0FayIsfLqQAAAAASUVORK5CYII=)";
      this._arrowSouth.style.bottom = "-12px";
      this._arrowSouth.style.left = "12px";

      this._balloon.appendChild(this._arrowSouth);

      this._arrowNorth = document.createElement('div');
      this._arrowNorth.style.position = "absolute";
      this._arrowNorth.style.width = "23px";
      this._arrowNorth.style.height = "12px";
      this._arrowNorth.style.background = "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAMCAYAAACJOyb4AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAbklEQVR4nGOx9zjDQCzwdNjzf/sBF0Zi1bOQYnB5eTmQ1Um0BUQZjjCYgYEUCwgajmwwDBBrAV7DsRlMigU4DcdnMLEWYDWcGIOJsQDDcFIMJmQBiuHkGIzPArjhlBiMywIWahmMzQIWahqMbgEAJ8dd6R/OgzQAAAAASUVORK5CYII=)";
      this._arrowNorth.style.top = "-12px";
      this._arrowNorth.style.left = "12px";

      this._balloon.appendChild(this._arrowNorth);

      let popupClose = document.createElement('div');
      popupClose.style.position = "absolute";
      popupClose.style.background = "url(data:image/gif;base64,R0lGODlhEAAQAMQAAP39/f7+/vj4+NbW1vn5+cXFxfT09NXV1fv7+/Pz88jIyNTU1NLS0vf39/X19fz8/O3t7djY2MfHx9fX18HBwc/Pz9DQ0MvLy83Nzc7OzsrKysnJyczMzP///wAAAAAAACH5BAAAAAAALAAAAAAQABAAQAWIoMZwnMZllYVprLVwWycHnYbBco53FQnQBExhIOhgMIHA5WDIATqXTFFxkSFyWOwmloOgohxCrsI1TCiXRieDGThkG0t2nsvI6XO2bNmUPaNTXAAJERViGBtucFw5GxoZVVg7HQkHGhYSUWIyZDIWBRk5ARVDRRiRCEVOHQ9qHY4jJScpKy0vIQA7) no-repeat";
      popupClose.style.width = "16px";
      popupClose.style.height = "16px";
      popupClose.style.cursor = "pointer";
      popupClose.style.top = "3px";
      popupClose.style.right = "5px";


      popupClose.addEventListener('click', () => {
        this.hidePopup();
      });
      this._balloon.appendChild(popupClose);


      this._balloon.addEventListener('click', (event) => {
         event.stopPropagation();
      });


  };

  _resizeCanvas(size:ISize) {
  }


  linkToMap(map:Map) {
      this.map = map;

      this._initCanvas(map);
  };


  movePopup(mapPoint:IPoint) {
      var p = this.map.fromMapPoint(mapPoint);

      var top = this.map.height - p.y;
      var left = p.x;


      this._arrowNorth.style.display = 'none';
      this._arrowSouth.style.display = 'none';

      

      //Assesta la posizione se sono vicino al bordo superiore
      if (top > (this.height + 12)) {
        this._arrowSouth.style.display = '';
        top -= (this.height + 12);
        left -= 24;
      } else {
        this._arrowNorth.style.display = '';
         top += 12;
        left -= 24;
      }


      //Assesta la posizione se sono vicino al destro
      if (left > (this.map.width - this.width)) {
          this._arrowNorth.style.left = (this.width - 36)+"px";
          this._arrowSouth.style.left = (this.width - 36)+"px";
          left -= (this.width - 36 - 12);
      } else {
          this._arrowNorth.style.left = 12+"px";
          this._arrowSouth.style.left = 12+"px";
      }

      this._balloon.style.top = top + 'px';
      this._balloon.style.left = left + 'px';
  };


  showPopup(mapPoint:IPoint, content:string) {
      this.position = mapPoint;
      this.movePopup(this.position);
      this._balloonContent.innerHTML = content;
      this._balloon.style.display = ''
      return this._balloonContent;
  };

  hidePopup() {
    this._balloon.style.display = 'none'
    this.position = null;
  };

  draw() {
      if (this.position !== null) {
          this.movePopup(this.position);
      }
  }

}

export interface IKMSServiceInfo {
  bounds:IKMSServiceBounds;
  layers:IKMSServiceLayer[];

}

export interface IKMSServiceBounds {
  minX:number;
  minY:number;
  maxX:number;
  maxY:number;
}

export interface IKMSServiceLayer {
  name:string;
  layerIndex:number;
  group:string;
  caption:string;
  bounds:IKMSServiceBounds;
  visible:boolean;
  layerType:string;
  featureClassInfo:ILayerClassInfo;
}



export interface ILegendSymbol {
  value: string;
  label: string;
  imageData: string;
}


export interface ILayerClassInfo {
  featureType: number;
  fieldClass: string[];
  fieldName: string[];
}


export interface ILegendLayerInfo {
  groupPath: string;
  symbols: ILegendSymbol[];
  name: string;
  bounds: any;
  featureClassInfo: ILayerClassInfo;
  layerType: string;
  visible: boolean;
  group: string;
  layerIndex: number;
  caption: string;

  extraInfo:string;
}


export interface ILegendGroupInfo {
  name: string;
  path: string;
  children: ILegendGroupInfo[];
  caption: string;
  layersName: string[];
}


export interface ILegendInfo {
  embeddedImages: boolean;
  layers: ILegendLayerInfo[];
  root: ILegendGroupInfo;
}



